import React, { Component } from 'react';
import classnames from 'classnames';
import Tooltip from '../../common/Tooltip';
import { isFlagEditable } from '../../../featureFlags';

// styles
import './FeatureFlagsSection.css';

// Tooltip builds an UNQUOTED attribute selector (`[data-tooltip=${parent}]`)
// So this must stay a bare CSS identifier - no colons from the URN, no leading digit.
const domId = flagId => flagId.replace(/[^a-zA-Z0-9-_]/g, '-');

const noteFor = (def, superAdmin) => {
  if (def.killSwitch === true) return 'This feature is currently switched off for all users.';
  if (def.superAdminOnly === true && superAdmin !== true) return 'Only a super admin can change this setting.';
  return '';
};

class FeatureFlagsSection extends Component {
  state = { activeTooltip: null };

  showTooltip = id => this.setState({ activeTooltip: id });

  hideTooltip = () => this.setState({ activeTooltip: null });

  toggleTooltip = id => this.setState(prev => ({
    activeTooltip: prev.activeTooltip === id ? null : id
  }));

  closeTooltipOnEscape = event => {
    if (event.keyCode === 27) this.hideTooltip();
  }

  renderTooltip(def, id) {
    const active = this.state.activeTooltip === id;
    return (
      <span className="feature-flag-help">
        <button
          type="button"
          className="icon icon-circle-help gdocs-valign-middle hintText-icon"
          data-tooltip={id}
          aria-label={`More information about ${def.label}`}
          aria-expanded={active}
          aria-describedby={`${id}-tooltip`}
          onMouseEnter={() => this.showTooltip(id)}
          onMouseLeave={this.hideTooltip}
          onFocus={() => this.showTooltip(id)}
          onBlur={this.hideTooltip}
          onClick={() => this.toggleTooltip(id)}
          onKeyUp={this.closeTooltipOnEscape}
        />
        <Tooltip active={active} position="right" arrow="center" parent={id}>
          <div className="tooltip-content-hintText">
            <span role="status" id={`${id}-tooltip`}>{def.description}</span>
          </div>
        </Tooltip>
      </span>
    );
  }

  renderNote(id, note) {
    if (!note) return null;
    // return <p id={`${id}-note`} className="feature-flag-note">{note}</p>;
    return (
      <div className="feature-flag-note" id={`${id}-note`}>
        <i className="icon icon-circle-error-solid gdocs-banner__icon gdocs-banner__icon--primary" aria-hidden="true"></i>
        <span>{note}</span>
      </div>
    );
  }

  render() {
    const { definitions, values, onChange, superAdmin, heading, route } = this.props;
    const active = (definitions || []).filter(def => def.active === true);

    if (active.length === 0) return null;

    return (
      <div className={classnames('user-detail--section', 'feature-flags-section', route.includes('/create-user') && 'create-user')}>
        <h3>{heading}</h3>
        {active.map(def => {
          const editable = isFlagEditable(def, superAdmin);
          const id = domId(def.id);
          const value = values[def.id];
          const note = noteFor(def, superAdmin);

          return (
            <div className="feature-flag-subsection" key={def.id}>
              <div className="feature-flag-row">
                <fieldset
                  className={editable ? 'feature-flag-group' : 'feature-flag-group disabled'}
                  disabled={!editable}
                  aria-describedby={note ? `${id}-note` : undefined}
                >
                  <legend>{def.label}</legend>
                  <label htmlFor={`${id}-yes`}>
                    <input
                      type="radio"
                      id={`${id}-yes`}
                      name={id}
                      value="true"
                      checked={value === true}
                      disabled={!editable}
                      onChange={() => onChange(def.id, true)}
                    />
                    Yes
                  </label>
                  <label htmlFor={`${id}-no`}>
                    <input
                      type="radio"
                      id={`${id}-no`}
                      name={id}
                      value="false"
                      checked={value === false}
                      disabled={!editable}
                      onChange={() => onChange(def.id, false)}
                    />
                    No
                  </label>
                </fieldset>
                {this.renderTooltip(def, id)}
              </div>
              {this.renderNote(id, note)}
            </div>
          );
        })}
      </div>
    );
  }
}

export default FeatureFlagsSection;


// WEBPACK FOOTER //
// ./src/components/Admin/UserDetail/FeatureFlagsSection.js